/**
 * Configuração centralizada para escolha da fonte de dados
 * Permite alternar entre backend local e Supabase
 */

export type DataSource = 'backend' | 'supabase';

export const DATA_SOURCE: DataSource = (import.meta.env.VITE_DATA_SOURCE as DataSource) || 'backend';

export const isBackendMode = (): boolean => DATA_SOURCE === 'backend';
export const isSupabaseMode = (): boolean => DATA_SOURCE === 'supabase';

// Configurações específicas do backend
export const BACKEND_CONFIG = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  USE_LOCAL_DB: import.meta.env.NEXT_PUBLIC_USE_LOCAL_DB === 'true',
  POSTGRES: {
    HOST: import.meta.env.POSTGRES_HOST || 'localhost',
    PORT: parseInt(import.meta.env.POSTGRES_PORT || '5432'),
    DB: import.meta.env.POSTGRES_DB || 'mendes_consorcio',
    USER: import.meta.env.POSTGRES_USER || 'postgres',
    PASSWORD: import.meta.env.POSTGRES_PASSWORD || 'postgres',
  },
  JWT_SECRET: import.meta.env.JWT_SECRET || '',
} as const;

// Configurações específicas do Supabase
export const SUPABASE_CONFIG = {
  URL: import.meta.env.VITE_SUPABASE_URL || 'https://bcnyytxudxfajapudanr.supabase.co',
  ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJjbnl5dHh1ZHhmYWphcHVkYW5yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcyMzA5MDEsImV4cCI6MjA2MjgwNjkwMX0.chWCrPswBxw6Ic2LSwkNh-YlYKH_zNT6Z1bjj3zgeOU',
} as const;

// Configurações gerais da aplicação
export const APP_CONFIG = {
  NAME: import.meta.env.VITE_APP_NAME || 'Omni',
  VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  ENVIRONMENT: import.meta.env.VITE_APP_ENVIRONMENT || 'development',
} as const;

// Função para validar configuração
export const validateConfig = (): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  if (DATA_SOURCE === 'backend') {
    if (!BACKEND_CONFIG.API_URL) {
      errors.push('VITE_API_URL é obrigatório quando VITE_DATA_SOURCE=backend');
    }
  } else if (DATA_SOURCE === 'supabase') {
    if (!SUPABASE_CONFIG.URL) {
      errors.push('VITE_SUPABASE_URL é obrigatório quando VITE_DATA_SOURCE=supabase');
    }
    if (!SUPABASE_CONFIG.ANON_KEY) {
      errors.push('VITE_SUPABASE_ANON_KEY é obrigatório quando VITE_DATA_SOURCE=supabase');
    }
  } else {
    errors.push(`VITE_DATA_SOURCE deve ser 'backend' ou 'supabase', recebido: ${DATA_SOURCE}`);
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

// Log da configuração atual (apenas em desenvolvimento)
if (import.meta.env.DEV) {
  const validation = validateConfig();
  if (!validation.isValid) {
    console.error('❌ Erro na configuração:', validation.errors);
  }
}
